 <!--
# -----------------------------------------------------------------------------
# Component: Policy.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Manage Policy main page
# -----------------------------------------------------------------------------
-->
 <template>
  <page :manualInit="policyGeneralSettings.init" :manualErr="policyGeneralSettings.initErr" @reload="doInit">
    <template slot="pageAction">
      <div class="actionBlock">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" @click="lifeCycle = !lifeCycle" v-on="on">
              Overview
              <v-icon right>mdi-file-document-box</v-icon>
            </v-btn>
          </template>
          <span>Overview</span>
        </v-tooltip>
      </div>
    </template>
    <div>
      <v-stepper v-model="stepForm.step" class="ma-0 pa-0">
        <v-stepper-header non-linear class="ma-0 pa-0">
          <v-stepper-step step="1" editable @click.native="changeStep(1)">General</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" editable @click.native="changeStep(2)">Policy Header</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" editable @click.native="changeStep(3)">Risk</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" editable @click.native="changeStep(4)">Summary</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5" editable @click.native="changeStep(5)">Reinsurance</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items class="ma-0 pa-0">
          <v-flex xs12 order-xs2 order-lg1 v-if="policyInfo.polNo !== undefined">
            <v-sheet style="background-color: #00acc1ff" elevation="2">
              <v-card-text class="pt-3">
                <v-flex xs12 class="text-xs-left">
                  <span style="color: white">
                    <span class="toolbar-title-1">{{ policyInfo.polNo }}</span>
                    <small class="toolbar-title-0"> - </small>
                    <span class="toolbar-title-1">{{ policyInfo.renCnt }}/{{ policyInfo.endtCnt }}</span>
                    <small class="toolbar-title-0"> - </small>
                    <span class="toolbar-title-1">{{ policyInfo.insured }}</span>
                  </span>
                </v-flex>
              </v-card-text>
            </v-sheet>
          </v-flex>
          <v-container fluid grid-list-sm>
            <v-flex xs12 order-xs2 order-lg1>
              <v-card class="ma-2 pa-0">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 order-xs2 order-lg1>
                      <router-view ref="childComponent"></router-view>
                      <promptLeave title="Policy" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-stepper-items>
      </v-stepper>
      <v-navigation-drawer temporary fixed clipped right app v-model="lifeCycle" width="450">
        <policy-info></policy-info>
      </v-navigation-drawer>
    </div>
  </page>
</template>

<script>
import { POLICY_LIFECYCLE, POLICY_HEADER_TAB, POLICY_RISK_TAB, POLICY_SUMMARY_TAB, POLICY_REINSURANCE_TAB } from '@/store/types'
import PolicyInfo from './PolicyInfo'
import { leavePolicy } from './leavePolicy'
import PromptLeave from './leavePolicy/PromptLeave'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      lifeCycle: false,
      breadcrumb: []
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    initStatus() {
      return this.$store.state.underwriting.policyGeneralSettings.init
    },
    policyLifeCycle() {
      return this.$store.state.underwriting.policy.policyLifeCycle
    },
    policyGeneralSettings() {
      return this.$store.state.underwriting.policyGeneralSettings
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    policyRiskTab() {
      return this.$store.state.underwriting.policy.policyRiskTab
    },
    policyHeaderTab() {
      return this.$store.state.underwriting.policy.policyHeaderTab
    },
    policySummaryTab() {
      return this.$store.state.underwriting.policy.policySummaryTab
    },
    policyReinsuranceTab() {
      return this.$store.state.underwriting.policy.policyReinsuranceTab
    },
    stepForm() {
      return this.$store.state.underwriting.policy.stepForm
    }
  },
  components: {
    PolicyInfo,
    PromptLeave
  },
  watch: {
    policyLifeCycle: function (value) {
      this.stepForm.step = this.policyLifeCycle
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.underwriting.policyGeneralSettings.init !== 1) {
        await this.$store.dispatch('policyGeneralInit')
      }
      if (this.$store.state.underwriting.policyHeaderSettings.init !== 1) {
        await this.$store.dispatch('policyHeaderInit')
      }
    },
    genComponent() {
      return this.$refs.childComponent
    },
    riskComponent() {
      return this.$refs.childComponent.$refs.childComponent
    },
    expandRiskDetails() {
      if (this.riskComponent().busClsAppID === 'BD') {
        if (this.riskComponent().$refs.polBondRisk) {
          this.riskComponent().$refs.polBondRisk.detail_panel = [0]
        }
      } else if (this.riskComponent().busClsAppID === 'FI') {
        if (this.riskComponent().$refs.polFireRisk) {
          this.riskComponent().$refs.polFireRisk.detail_panel = [0]
        }
      } else if (this.riskComponent().busClsAppID === 'MO') {
        if (this.riskComponent().$refs.polMtrRisk) {
          this.riskComponent().$refs.polMtrRisk.detail_panel = [0]
        }
      } else if (this.riskComponent().busClsAppID === 'HU') {
        if (this.riskComponent().$refs.polHullRisk) {
          this.riskComponent().$refs.polHullRisk.detail_panel = [0]
        }
      } else if (this.riskComponent().busClsAppID === 'CA') {
        if (this.riskComponent().$refs.polCargoRisk) {
          this.riskComponent().$refs.polCargoRisk.detail_panel = [0]
        }
      }
    },
    changeStep(step) {
      this.resetMessages()
      if (this.policyLifeCycle === 1 && this.policyLifeCycle !== step) {
        this.genComponent()
          .doValidateAllWarn()
          .then((result2) => {
            if (result2) {
              this.genComponent()
                .$validator.validateAll()
                .then((result) => {
                  if (result) {
                    this.genComponent().policy.saving = true
                    this.genComponent()
                      .doPolMasterSave()
                      .then((success) => {
                        if (success) {
                          this.genComponent().policy.saving = false
                          if (step === 1) {
                            this.stepForm.step = step
                            this.$store.commit(POLICY_LIFECYCLE, step)
                            this.$router.push({ name: 'policyGeneral' })
                          } else if (step === 2) {
                            this.stepForm.step = step
                            this.$store.commit(POLICY_LIFECYCLE, step)
                            this.$store.commit(POLICY_HEADER_TAB, 0)
                            this.$router.push({ name: 'policyHeader' })
                          } else if (step === 3) {
                            if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                              this.$toast.error(this.failedMessagePolHeader())
                              this.stepForm.step = 1
                            } else {
                              this.stepForm.step = step
                              this.$store.commit(POLICY_LIFECYCLE, step)
                              this.$store.commit(POLICY_RISK_TAB, 0)
                              this.$router.push({ name: 'policyRisk' })
                            }
                          } else if (step === 4) {
                            if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                              this.$toast.error(this.failedMessagePolHeader())
                              this.stepForm.step = 1
                            } else {
                              this.stepForm.step = step
                              this.$store.commit(POLICY_LIFECYCLE, step)
                              this.$store.commit(POLICY_SUMMARY_TAB, 0)
                              this.$router.push({ name: 'policySummary' })
                            }
                          } else if (step === 5) {
                            this.stepForm.step = step
                            this.$store.commit(POLICY_LIFECYCLE, step)
                            this.$store.commit(POLICY_REINSURANCE_TAB, 0)
                            this.$router.push({ name: 'policyReinsurance' })
                          }
                        } else {
                          this.$toast.error('Policy Record Save Failed')
                        }
                      })
                  } else {
                    this.promptFieldCheck()
                    this.stepForm.step = this.policyLifeCycle
                  }
                })
            } else {
              this.stepForm.step = this.policyLifeCycle
            }
          })
      } else if (this.policyLifeCycle === 2 && this.policyLifeCycle !== step) {
        if (this.$refs.childComponent.headers !== 3) {
          this.resetMessages()
          this.$refs.childComponent.$refs.childComponent.doValidateAllWarn().then((result2) => {
            if (result2) {
              this.$refs.childComponent.$refs.childComponent.$validator.validateAll().then((result) => {
                if (result) {
                  this.$refs.childComponent.$refs.childComponent.policy.saving = true
                  // this.processing = true

                  if (this.$refs.childComponent.headers === 0) {
                    this.$store.dispatch('policyMain', this.$refs.childComponent.$refs.childComponent.mainForm)
                  } else if (this.$refs.childComponent.headers === 1) {
                    this.$store.dispatch('policyInsured', this.$refs.childComponent.$refs.childComponent.mainForm)
                  } else if (this.$refs.childComponent.headers === 2) {
                    this.$store.dispatch('policyOtherDetails', this.$refs.childComponent.$refs.childComponent.mainForm)
                  }
                  this.$refs.childComponent.$refs.childComponent.doPolMasterSave().then((success) => {
                    if (success) {
                      if (this.policyHeaderTab === 2) {
                        this.$refs.childComponent.$refs.childComponent.doProceedOtherDetails().then((success2) => {
                          if (success2) {
                            this.$refs.childComponent.$refs.childComponent.policy.saving = false
                            if (step === 1) {
                              this.stepForm.step = step
                              this.$store.commit(POLICY_LIFECYCLE, step)
                              this.$router.push({ name: 'policyGeneral' })
                            } else if (step === 3) {
                              if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                                this.$toast.error(this.failedMessagePolHeader())
                                this.stepForm.step = 2
                              } else {
                                this.stepForm.step = step
                                this.$store.commit(POLICY_LIFECYCLE, step)
                                this.$store.commit(POLICY_RISK_TAB, 0)
                                this.$router.push({ name: 'policyRisk' })
                              }
                            } else if (step === 4) {
                              if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                                this.$toast.error(this.failedMessagePolHeader())
                                this.stepForm.step = 2
                              } else {
                                this.stepForm.step = step
                                this.$store.commit(POLICY_LIFECYCLE, step)
                                this.$router.push({ name: 'policySummary' })
                              }
                            } else if (step === 5) {
                              this.stepForm.step = step
                              this.$store.commit(POLICY_LIFECYCLE, step)
                              this.$store.commit(POLICY_REINSURANCE_TAB, 0)
                              this.$router.push({ name: 'policyReinsurance' })
                            }
                          }
                        })
                      } else {
                        this.$refs.childComponent.$refs.childComponent.policy.saving = false
                        if (step === 1) {
                          this.stepForm.step = step
                          this.$store.commit(POLICY_LIFECYCLE, step)
                          this.$router.push({ name: 'policyGeneral' })
                        } else if (step === 3) {
                          if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                            this.$toast.error(this.failedMessagePolHeader())
                            this.stepForm.step = 2
                          } else {
                            this.stepForm.step = step
                            this.$store.commit(POLICY_LIFECYCLE, step)
                            this.$store.commit(POLICY_RISK_TAB, 0)
                            this.$router.push({ name: 'policyRisk' })
                          }
                        } else if (step === 4) {
                          if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
                            this.$toast.error(this.failedMessagePolHeader())
                            this.stepForm.step = 2
                          } else {
                            this.stepForm.step = step
                            this.$store.commit(POLICY_LIFECYCLE, step)
                            this.$router.push({ name: 'policySummary' })
                          }
                        } else if (step === 5) {
                          this.stepForm.step = step
                          this.$store.commit(POLICY_LIFECYCLE, step)
                          this.$store.commit(POLICY_REINSURANCE_TAB, 0)
                          this.$router.push({ name: 'policyReinsurance' })
                        }
                      }
                    } else {
                      this.$toast.error(this.failedMessage())
                      this.stepForm.step = this.policyLifeCycle
                    }
                  })
                } else {
                  this.promptFieldCheck()
                  this.stepForm.step = this.policyLifeCycle
                }
              })
            } else {
              this.stepForm.step = this.policyLifeCycle
            }
          })
        } else {
          this.$refs.childComponent.$refs.childComponent.loading = false
          if (step === 1) {
            this.stepForm.step = step
            this.$store.commit(POLICY_LIFECYCLE, step)
            this.$router.push({ name: 'policyGeneral' })
          } else if (step === 3) {
            if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
              this.$toast.error(this.failedMessagePolHeader())
              this.stepForm.step = 2
            } else {
              this.stepForm.step = step
              this.$store.commit(POLICY_LIFECYCLE, step)
              this.$store.commit(POLICY_RISK_TAB, 0)
              this.$router.push({ name: 'policyRisk' })
            }
          } else if (step === 4) {
            if (this.polMaster.acctNo1 === '' || this.polMaster.insdName1 === '') {
              this.$toast.error(this.failedMessagePolHeader())
              this.stepForm.step = 2
            } else {
              this.stepForm.step = step
              this.$store.commit(POLICY_LIFECYCLE, step)
              this.$router.push({ name: 'policySummary' })
            }
          } else if (step === 5) {
            this.stepForm.step = step
            this.$store.commit(POLICY_LIFECYCLE, step)
            this.$store.commit(POLICY_REINSURANCE_TAB, 0)
            this.$router.push({ name: 'policyReinsurance' })
          }
        }
      } else if (this.policyLifeCycle === 3 && this.policyLifeCycle !== step) {
        // Copied from PolicyRisk.vue doTab function
        if (this.policyRiskTab === 0) {
          this.riskComponent()
            .doTab()
            .then(() => {
              this.route(step)
            })
        } else if (this.policyRiskTab === 1) {
          this.resetMessages()
          this.expandRiskDetails()
          this.$validator.validateAll().then((result3) => {
            if (result3) {
              if (this.riskComponent().busClsAppID === 'BD') {
                if (this.riskComponent().$refs.polBondRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polBondRisk.$validator.validateAll()
                    .then((result2) => {
                      if (this.riskComponent().$refs.polBondRisk.workerForm.wrkmanNo !== undefined) {
                        this.riskComponent()
                          .$refs.polBondRisk.$validator.validateAll('workerForm')
                          .then((result) => {
                            if (result) {
                              this.riskComponent().policy.loading = true
                              this.riskComponent().$refs.polBondRisk.workerForm.polNo = this.riskComponent().$refs.polBondRisk.mainForm.polNo
                              this.riskComponent().$refs.polBondRisk.workerForm.renCnt = this.riskComponent().$refs.polBondRisk.mainForm.renCnt
                              this.riskComponent().$refs.polBondRisk.workerForm.endtCnt = this.riskComponent().$refs.polBondRisk.mainForm.endtCnt
                              this.riskComponent().$refs.polBondRisk.workerForm.riskGrpNo = this.riskComponent().$refs.polBondRisk.mainForm.riskGrpNo
                              this.riskComponent().$refs.polBondRisk.workerForm.riskNo = this.riskComponent().$refs.polBondRisk.mainForm.riskNo
                              this.riskComponent()
                                .$refs.polBondRisk.doPolMiscWrkmanSave()
                                .then((success) => {
                                  if (success) {
                                    this.riskComponent().$refs.polBondRisk.initWorkerForm()
                                    this.riskComponent().$refs.polBondRisk.displayWorkerList()
                                    this.riskComponent()
                                      .$refs.polBondRisk.doPolMiscEmpytSave()
                                      .then((success2) => {
                                        if (success2) {
                                          this.riskComponent()
                                            .doMiscRiskSave()
                                            .then((success3) => {
                                              if (success3) {
                                                this.route(step)
                                              } else {
                                                this.$toast.error(this.failedMessage('miscellaneous risk'))
                                                this.riskComponent().policy.loading = false
                                                this.stepForm.step = 3
                                              }
                                            })
                                        } else {
                                          this.$toast.error(this.failedMessage('policy bond risk'))
                                          this.riskComponent().policy.loading = false
                                          this.stepForm.step = 3
                                        }
                                      })
                                  } else {
                                    this.$toast.error(this.failedMessage('worker'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.promptFieldCheck()
                              this.stepForm.step = 3
                            }
                          })
                      } else if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polBondRisk.doPolMiscEmpytSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.route(step)
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy bond risk'))
                              this.riskComponent().policy.loading = false
                              this.stepForm.step = 3
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                        this.stepForm.step = 3
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'FI') {
                if (this.riskComponent().$refs.polFireRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polFireRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polFireRisk.doPolFireRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.route(step)
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy fire risk'))
                              this.riskComponent().policy.loading = false
                              this.stepForm.step = 3
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                        this.stepForm.step = 3
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'MO') {
              // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'MO') {
                if (this.riskComponent().$refs.polMtrRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polMtrRisk.$validator.validateAll()
                    .then((result2) => {
                      if (this.riskComponent().$refs.polMtrRisk.driverForm.seqNo !== undefined) {
                        this.riskComponent()
                          .$refs.polMtrRisk.$validator.validateAll('driverForm')
                          .then((result) => {
                            if (result) {
                              this.riskComponent().policy.loading = true
                              this.riskComponent().$refs.polMtrRisk.driverForm.polNo = this.riskComponent().$refs.polMtrRisk.mainForm.polNo
                              this.riskComponent().$refs.polMtrRisk.driverForm.renCnt = this.riskComponent().$refs.polMtrRisk.mainForm.renCnt
                              this.riskComponent().$refs.polMtrRisk.driverForm.endtCnt = this.riskComponent().$refs.polMtrRisk.mainForm.endtCnt
                              this.riskComponent().$refs.polMtrRisk.driverForm.riskGrpNo = this.riskComponent().$refs.polMtrRisk.mainForm.riskGrpNo
                              this.riskComponent().$refs.polMtrRisk.driverForm.riskNo = this.riskComponent().$refs.polMtrRisk.mainForm.riskNo
                              this.riskComponent()
                                .$refs.polMtrRisk.doPolMtrDrvSave()
                                .then((success) => {
                                  if (success) {
                                    this.riskComponent().$refs.polMtrRisk.initDriverForm()
                                    this.riskComponent().$refs.polMtrRisk.displayDriverList()
                                    this.riskComponent()
                                      .$refs.polMtrRisk.doPolMtrRiskSave()
                                      .then((success2) => {
                                        if (success2) {
                                          this.riskComponent()
                                            .doMiscRiskSave()
                                            .then((success3) => {
                                              if (success3) {
                                                this.route(step)
                                              } else {
                                                this.$toast.error(this.failedMessage('miscellaneous risk'))
                                                this.riskComponent().policy.loading = false
                                                this.stepForm.step = 3
                                              }
                                            })
                                        } else {
                                          this.$toast.error(this.failedMessage('policy motor risk'))
                                          this.riskComponent().policy.loading = false
                                          this.stepForm.step = 3
                                        }
                                      })
                                  } else {
                                    this.$toast.error(this.failedMessage('named driver'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.promptFieldCheck()
                              this.stepForm.step = 3
                            }
                          })
                      } else if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polMtrRisk.doPolMtrRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.route(step)
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy motor risk'))
                              this.riskComponent().policy.loading = false
                              this.stepForm.step = 3
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                        this.stepForm.step = 3
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'HU') {
              // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'HU') {
                if (this.riskComponent().$refs.polHullRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polHullRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polHullRisk.doPolHullRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.route(step)
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy hull risk'))
                              this.riskComponent().policy.loading = false
                              this.stepForm.step = 3
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                        this.stepForm.step = 3
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'CA') {
              // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'CA') {
                if (this.riskComponent().$refs.polCargoRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polCargoRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polCargoRisk.doPolCargoRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.route(step)
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                    this.stepForm.step = 3
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy cargo risk'))
                              this.riskComponent().policy.loading = false
                              this.stepForm.step = 3
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                        this.stepForm.step = 3
                      }
                    })
                }
              }
            } else {
              this.promptFieldCheck()
            }
          })
        } else if (this.policyRiskTab === 2) {
          this.riskComponent().policy.saving = true
          this.resetMessages()
          this.$validator.validateAll().then((result) => {
            if (result) {
              if (
                this.riskComponent().$refs.polItemUOM.mainForm.seqNo !== undefined &&
                this.riskComponent().$refs.polItemBen.mainForm.seqNo !== undefined
              ) {
                this.riskComponent().$refs.polItemUOM.policy.loading = true
                this.riskComponent()
                  .$refs.polItemUOM.doPolItemUOMSave()
                  .then((success) => {
                    if (success) {
                      this.riskComponent().$refs.polItemUOM.doInitForm()
                      this.riskComponent().$refs.polItemUOM.getPolItemUOMList()
                      this.riskComponent().$refs.polItemBen.policy.loading = true
                      this.riskComponent()
                        .$refs.polItemBen.doPolItemBenSave()
                        .then((success2) => {
                          if (success2) {
                            this.riskComponent().$refs.polItemBen.doInitForm()
                            this.riskComponent().$refs.polItemBen.getPolItemBenList()
                            this.riskComponent().$refs.polItemBen.$emit('itemList')
                            if (this.riskComponent().$refs.polDiscLdg) {
                              this.riskComponent()
                                .$refs.polDiscLdg.$validator.validateAll()
                                .then((result2) => {
                                  if (result2) {
                                    this.riskComponent().policy.loading = true
                                    this.riskComponent()
                                      .$refs.polDiscLdg.doSaveDiscLdg()
                                      .then((success) => {
                                        if (success) {
                                          this.riskComponent()
                                            .$refs.polDiscLdg.doPolMasterSave()
                                            .then((success2) => {
                                              if (success2) {
                                                this.route(step)
                                              } else {
                                                this.$toast.error(this.failedMessage())
                                              }
                                            })
                                        } else {
                                          this.$toast.error(this.failedMessage())
                                        }
                                        this.riskComponent().policy.loading = false
                                        this.riskComponent().policy.saving = false
                                      })
                                  } else {
                                    this.promptFieldCheck()
                                  }
                                })
                            } else {
                              this.route(step)
                              this.riskComponent().policy.saving = false
                            }
                          } else {
                            this.$toast.error(this.failedMessage('policy item benefit'))
                          }
                          this.riskComponent().$refs.polItemBen.policy.loading = false
                        })
                    } else {
                      this.$toast.error(this.failedMessage('policy SI'))
                    }
                    this.riskComponent().$refs.polItemUOM.policy.loading = false
                  })
              } else if (this.riskComponent().$refs.polItemUOM.mainForm.seqNo !== undefined) {
                this.riskComponent().policy.saving = true
                this.riskComponent()
                  .$refs.polItemUOM.doSaveUOM()
                  .then(() => {
                    if (this.riskComponent().$refs.polDiscLdg) {
                      this.riskComponent()
                        .$refs.polDiscLdg.$validator.validateAll()
                        .then((result2) => {
                          if (result2) {
                            this.riskComponent().policy.loading = true

                            this.riskComponent()
                              .$refs.polDiscLdg.doSaveDiscLdg()
                              .then((success) => {
                                if (success) {
                                  this.riskComponent()
                                    .$refs.polDiscLdg.doPolMasterSave()
                                    .then((success2) => {
                                      if (success2) {
                                        this.riskComponent().getRiskItemList()
                                        this.route(step)
                                      } else {
                                        this.$toast.error(this.failedMessage())
                                      }
                                    })
                                } else {
                                  this.$toast.error(this.failedMessage())
                                }
                                this.riskComponent().policy.loading = false
                                this.riskComponent().policy.saving = false
                              })
                          } else {
                            this.promptFieldCheck()
                          }
                        })
                    } else {
                      this.route(step)
                      this.riskComponent().policy.saving = false
                    }
                  })
              } else if (this.riskComponent().$refs.polItemBen.mainForm.seqNo !== undefined) {
                this.riskComponent().policy.saving = true
                this.riskComponent()
                  .$refs.polItemBen.doSave()
                  .then(() => {
                    if (this.riskComponent().$refs.polDiscLdg) {
                      this.riskComponent()
                        .$refs.polDiscLdg.$validator.validateAll()
                        .then((result2) => {
                          if (result2) {
                            this.riskComponent().policy.loading = true

                            this.riskComponent()
                              .$refs.polDiscLdg.doSaveDiscLdg()
                              .then((success) => {
                                if (success) {
                                  this.riskComponent()
                                    .$refs.polDiscLdg.doPolMasterSave()
                                    .then((success2) => {
                                      if (success2) {
                                        this.riskComponent().getRiskItemList()
                                        this.route(step)
                                      } else {
                                        this.$toast.error(this.failedMessage())
                                      }
                                    })
                                } else {
                                  this.$toast.error(this.failedMessage())
                                }
                                this.riskComponent().policy.loading = false
                                this.riskComponent().policy.saving = false
                              })
                          } else {
                            this.promptFieldCheck()
                          }
                        })
                    } else {
                      this.route(step)
                      this.riskComponent().policy.saving = false
                    }
                  })
              } else {
                this.route(step)
              }
            } else {
              this.promptFieldCheck()
            }
          })
        } else if (this.policyRiskTab === 3) {
          this.resetMessages()
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.riskComponent().policy.saving = true
              this.riskComponent()
                .saveRiskTrailers()
                .then((success) => {
                  if (success) {
                    this.route(step)
                  } else {
                    this.$toast.error('Risk Trailer Save Failed')
                    this.stepForm.step = this.policyLifeCycle
                  }
                  this.riskComponent().policy.saving = false
                })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      } else if (this.policyLifeCycle === 4 && this.policyLifeCycle !== step) {
        if (this.policySummaryTab === 0) {
          this.riskComponent().policy.saving = true
          this.riskComponent()
            .doPolMasterSave()
            .then((success) => {
              if (success) {
                this.route(step)
                this.riskComponent().policy.saving = false
              } else {
                this.$toast.error('Policy Save Failed')
                this.riskComponent().policy.saving = false
              }
            })
        } else if (this.policySummaryTab === 1) {
          this.resetMessages()
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.riskComponent().policy.saving = true
              this.riskComponent()
                .savePremInstalBill()
                .then((success) => {
                  if (success) {
                    this.riskComponent()
                      .doProceed()
                      .then((success2) => {
                        if (success2) {
                          this.route(step)
                        } else {
                          this.stepForm.step = 4
                        }
                      })
                  } else {
                    this.$toast.error('Instalment Details Save Failed')
                  }
                  this.riskComponent().policy.saving = false
                })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      } else {
        this.route(step)
      }
    },
    route(step) {
      this.stepForm.step = step
      this.$store.commit(POLICY_LIFECYCLE, step)
      if (step === 1) {
        this.$router.push({ name: 'policyGeneral' })
      } else if (step === 2) {
        this.$store.commit(POLICY_HEADER_TAB, 0)
        this.$router.push({ name: 'policyHeader' })
      } else if (step === 3) {
        this.$store.commit(POLICY_RISK_TAB, 0)
        this.$router.push({ name: 'policyRisk' })
      } else if (step === 4) {
        this.$store.commit(POLICY_SUMMARY_TAB, 0)
        this.$router.push({ name: 'policySummary' })
      } else if (step === 5) {
        this.$store.commit(POLICY_REINSURANCE_TAB, 0)
        this.$router.push({ name: 'policyReinsurance' })
      }
    },
    changeGeneral() {
      this.resetMessages()
      this.$refs.childComponent.$validator.validateAll().then((result) => {
        if (result) {
          this.stepForm.step = 1
          this.$store.commit(POLICY_LIFECYCLE, 1)
          this.$router.push({ name: 'policyGeneral' })
        } else {
          this.promptFieldCheck()
          this.stepForm.step = this.policyLifeCycle
        }
      })
    },
    changeHeader() {
      this.resetMessages()
      this.$refs.childComponent.$validator.validateAll().then((result) => {
        if (result) {
          this.stepForm.step = 2
          this.$store.commit(POLICY_LIFECYCLE, 2)
          this.$router.push({ name: 'policyHeader' })
        } else {
          this.promptFieldCheck()
          this.stepForm.step = this.policyLifeCycle
        }
      })
    },
    changeRisk() {
      this.resetMessages()
      this.$refs.childComponent.$validator.validateAll().then((result) => {
        if (result) {
          this.stepForm.step = 3
          this.$store.commit(POLICY_LIFECYCLE, 3)
          this.$store.commit(POLICY_RISK_TAB, 0)
          this.$router.push({ name: 'policyRisk' })
        } else {
          this.promptFieldCheck()
          this.stepForm.step = this.policyLifeCycle
        }
      })
    },
    changeSummary() {
      this.resetMessages()
      this.$refs.childComponent.$validator.validateAll().then((result) => {
        if (result) {
          this.stepForm.step = 4
          this.$store.commit(POLICY_LIFECYCLE, 4)
          this.$store.commit(POLICY_SUMMARY_TAB, 0)
          this.$router.push({ name: 'policySummary' })
        } else {
          this.promptFieldCheck()
          this.stepForm.step = this.policyLifeCycle
        }
      })
    },
    successMessage() {
      return 'Policy record successfully saved.'
    },
    failedMessage(module) {
      if (module === '' || module === undefined) {
        return 'An unexpected error occured while saving policy record.'
      } else {
        return 'An unexpected error occured while saving ' + module + ' record.'
      }
    },
    failedMessagePolHeader() {
      return 'Please fill in required fields under Policy Header.'
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
    this.stepForm.step = this.policyLifeCycle
  },
  mixins: [leavePolicy, MessageMixin]
}
</script>
